import counterBottom from '../__utils/number-counter';
import { counterMiddle } from '../__utils/number-counter';
import CircularLoader from '../__utils/circular-loader';

class Tabs {
    constructor(wrapper, tabListItem, tabWrapper, tabItem, singleProdOverlay) {
        this.wrapper = wrapper;
        this.tabListItem = tabListItem;
        this.tabWrapper = tabWrapper;
        this.tabItem = tabItem;
        this.singleProdOverlay = singleProdOverlay;
    }
    saveDataAttributes(articleInfo) {
        const activeTabItem = articleInfo.querySelector('.tab-item.is-active');
        this.tabObj = {};

        // assign values from data attr to object
        for (var i = 0; i < activeTabItem.attributes.length; i++) {
            const attr = activeTabItem.attributes[i];
            if (/^data-/.test(attr.nodeName)) {
                const key = attr.nodeName.replace(/^data-/, '');
                const value = attr.nodeValue;
                this.tabObj[key] = value;
            }
        }
    }
    switchTabs(e) {

        // establishing correct active tab list item depending what was clicked
        let activetabListItem = e.currentTarget;
        if (!activetabListItem.classList.contains('tab-list-item')) {
            activetabListItem = e.target.parentNode;
        }
        const articleInfo = activetabListItem.parentNode.parentNode.parentNode;
        let tabListItems = articleInfo.querySelectorAll('.tab-list-item');
        const tabWrapper = articleInfo.querySelector(this.tabWrapper);
        let activeTabItems = tabWrapper.querySelectorAll(this.tabItem);
        const activeTabClass = activetabListItem.getAttribute('data-tab');
        let tabItems = articleInfo.querySelectorAll(this.tabItem);

        // save attributes from the last tab when switch to another one
        this.saveDataAttributes(articleInfo);

        // removing active class form all tab list items and tab items
        if (tabListItems) {
            tabListItems = Array.prototype.slice.call(tabListItems);
            tabListItems.forEach(tab => {
                if (tab.classList.contains('is-active')) {
                    tab.classList.remove('is-active');
                }
            });
        }

        if (tabItems) {
            tabItems = Array.prototype.slice.call(tabItems);
            tabItems.forEach(tabItem => {
                if (tabItem.classList.contains('is-active')) {
                    tabItem.classList.remove('is-active');
                }
            });
        }

        // adding active class to chosen tab list item and tab item
        activetabListItem.classList.add('is-active');

        if (activeTabItems) {
            activeTabItems = Array.prototype.slice.call(activeTabItems);
            activeTabItems.forEach((tabItem) => {
                if (tabItem.classList.contains(activeTabClass)) {
                    tabItem.classList.add('is-active');
                }
            });
        }


        // starting the counters
        counterBottom.init(this.tabObj);
        counterMiddle.init(this.tabObj);
        CircularLoader.init(this.tabObj);

    }
    init() {
        let tabListItem = document.querySelectorAll(this.tabListItem);
        const singleProdOverlay = document.querySelector(this.singleProdOverlay);
        let tabsInProdOverlay;
        if (singleProdOverlay) {
            tabsInProdOverlay = singleProdOverlay.querySelectorAll(this.tabListItem);
        }

        // attach event listener to existing tab elements
        if (tabListItem) {
            tabListItem = Array.prototype.slice.call(tabListItem);
            tabListItem.forEach((element) => {
                element.addEventListener("click", (e) => this.switchTabs(e));
            });
        }

        // attach event listener to tab elements in single-prod-overlay
        if (tabsInProdOverlay) {
            singleProdOverlay.addEventListener('click', (e) => {
                const target = e.target.parentNode;
                if (target.classList.contains('tab-list-item')) {
                    this.switchTabs(e);
                }
            });
        }
    }
}

export default new Tabs('.article-info', '.tab-list-item', '.tab-wrapper', '.tab-item', '.single-prod-over');